import { Group } from '../types/entities/Group';
import api from './api';
import { Client } from './Client';

export class GroupClient extends Client<Group> {
  constructor() {
    super('/groups');
  }

  public async lock(id: Group['id'], searchParams: any): Promise<Group> {
    const searchParamsCopy = new URLSearchParams(searchParams);

    return await api.get(`/lock/${id}`, searchParamsCopy);
  }

  public async kick(id: Group['id'], searchParams: any): Promise<Group> {
    const searchParamsCopy = new URLSearchParams(searchParams);
    return await api.get(`/kick/${id}`, searchParamsCopy);
  }

  public async changeSize(id: Group['id'], change: number): Promise<Group> {
    return await api.patch<undefined, Group>(
      `${this.urlPath}/${id}/size?change=${change}`,
      undefined
    );
  }
}
